var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7501 25.9959V22.0059",
    stroke: "#00D27E",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.755 23.999H13.745",
    stroke: "#00D27E",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.597 16.499C9.67695 16.499 7.75845 17.231 6.29295 18.6965C3.36345 21.626 3.36345 26.3735 6.29295 29.303C9.22245 32.2325 13.97 32.2325 16.8995 29.303H20.1005C23.03 32.2325 27.7774 32.2325 30.7069 29.303C33.6364 26.3735 33.6364 21.626 30.7069 18.6965C29.2429 17.231 27.323 16.499 25.403 16.499H11.597V16.499Z",
    stroke: "#00D27E",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5025 25.2266C26.7095 25.2266 26.8775 25.3946 26.876 25.6016C26.876 25.8086 26.708 25.9766 26.501 25.9766C26.294 25.9766 26.126 25.8086 26.126 25.6016C26.1275 25.3946 26.2955 25.2266 26.5025 25.2266",
    stroke: "#00D27E",
    strokeOpacity: 0.5,
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3015 22.0244C23.5085 22.0244 23.6765 22.1924 23.675 22.3994C23.675 22.6064 23.507 22.7744 23.3 22.7744C23.093 22.7744 22.925 22.6064 22.925 22.3994C22.9265 22.1924 23.0945 22.0244 23.3015 22.0244",
    stroke: "#00D27E",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 16.5V14.25C18.5 12.18 20.1785 10.5 22.25 10.5V10.5C24.3215 10.5 26 8.8215 26 6.75V4.5",
    stroke: "#00D27E",
    strokeOpacity: 0.5,
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.19dd3db18b9f527d61d4c476567271a9.svg";
export { ForwardRef as ReactComponent };